<section class="option-card" [class.disabled]="disabled">
  <header class="option-card-header">
    <span class="option-card-title">
      @if (icon) {
        <mat-icon>{{ icon }}</mat-icon>
      }
      {{ title | translate }}
    </span>

    @if (switchable) {
      <mat-slide-toggle [checked]="enabled && !disabled" [disabled]="disabled" (change)="toggled.emit($event.checked)"
        [attr.aria-label]="(toggleLabel || title) | translate">
        {{ toggleLabel ? (toggleLabel | translate) : '' }}
      </mat-slide-toggle>
    }
  </header>

  @if (disabled && reason) {
    <p class="option-card-reason">{{ reason | translate }}</p>
  }

  @if ((enabled || !switchable) && !disabled) {
    <div class="option-card-body">
      <ng-content></ng-content>
    </div>
  }
</section>
